"use client";

import { useEffect, useRef } from "react";

export default function JotformHipaaPrivacyWaiverEmbed() {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = "";
    const script = document.createElement("script");
    script.src = "https://form.jotform.com/jsform/250133717348051";
    script.type = "text/javascript";
    script.async = true;
    container.appendChild(script);
  }, []);

  return <div ref={containerRef} className="w-full min-h-[400px]" />;
}
